"use client";
import { useRouter, usePathname, useSearchParams } from "next/navigation";

export const ClearSortFilter = () => {
  const router = useRouter();
  const searchParams = useSearchParams();

  const handleClear = () => {
    router.push('/'); // ✅ removes all query params
  };

  // ✅ check if any query exists
  const hasParams = searchParams.toString().length > 0;

  if (!hasParams) return null; // ❌ hide button

  return (
    <button
      onClick={handleClear}
      className="border-1 p-2 pl-3 pr-3 border-200 text-900 cursor-pointer border-round-md surface-10"
      style={{ height: "40px" }}
    >
      Clear
    </button>
  );
};